import { render } from "./paper.vue?vue&type=template&id=491a8e0a&scoped=true&ts=true"
import script from "./paper.vue?vue&type=script&lang=ts"
export * from "./paper.vue?vue&type=script&lang=ts"

import "./paper.vue?vue&type=style&index=0&id=491a8e0a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491a8e0a"]])

export default __exports__